/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './op-procedure-order.reducer';

export const OpProcedureOrderDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const opProcedureOrderEntity = useAppSelector(state => state.opProcedureOrder.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="opProcedureOrderDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.opProcedureOrder.detail.title">OpProcedureOrder</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrder.id">Id</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrder.active">Active</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrder.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrder.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderEntity.timestampEntry}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrder.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderEntity.lastUpdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrder.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderEntity.cursor}</dd>
          <dt>
            <span id="totalCost">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrder.totalCost">Total Cost</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderEntity.totalCost}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrder.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderEntity.notes}</dd>
          <dt>
            <span id="orderStatus">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrder.orderStatus">Order Status</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderEntity.orderStatus}</dd>
          <dt>
            <span id="billed">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrder.billed">Billed</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderEntity.billed ? 'true' : 'false'}</dd>
          <dt>
            <span id="procedureStatus">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrder.procedureStatus">Procedure Status</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderEntity.procedureStatus}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.opProcedureOrder.appointment">Appointment</Translate>
          </dt>
          <dd>{opProcedureOrderEntity.appointment ? opProcedureOrderEntity.appointment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.opProcedureOrder.scheme">Scheme</Translate>
          </dt>
          <dd>{opProcedureOrderEntity.scheme ? opProcedureOrderEntity.scheme.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.opProcedureOrder.patient">Patient</Translate>
          </dt>
          <dd>{opProcedureOrderEntity.patient ? opProcedureOrderEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.opProcedureOrder.issuedBy">Issued By</Translate>
          </dt>
          <dd>{opProcedureOrderEntity.issuedBy ? opProcedureOrderEntity.issuedBy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/op-procedure-order" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/op-procedure-order/${opProcedureOrderEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default OpProcedureOrderDetail;
